export default __webpack_public_path__ + "static/media/s-circle.4ffbdaf7.svg";